<template>
  <b-col class="pb-4">
    <b-table  v-on:row-clicked="clickedEmit($event)"  :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage" class="table-show-recursos">
      <!--<template  slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="tags" slot-scope="data">
        <p style="font-size:1rem;">{{ joinArray(data.item.tags) }}</p>
      </template>-->
      <template slot="fechaUltimaActualizacion" slot-scope="data">
         <p>{{ data.item.fechaUltimaActualizacion | moment("DD/MM/YYYY") }}</p>
      </template>

      <template slot="actions" slot-scope="data">

        <div v-if="data.item.typeRec == 'dirs'">
          <button  v-b-popover.hover="'Restaurar Directorio'" class="btn" v-if="data.item.estatus == 'INACTIVO'" @click="restoreDir(data.item)">
              <font-awesome-icon icon="trash-restore"/>
          </button>
          <button  v-b-popover.hover="'Cambiar Nombre'" class="btn" v-if="data.item.estatus == 'ACTIVO'" @click="changeName(data.item)">
              <font-awesome-icon icon="edit"/>
          </button>
          <button  v-b-popover.hover="'Eliminar Directorio'" class="btn" v-if="data.item.estatus == 'ACTIVO'" @click="removeDir(data.item)">
              <font-awesome-icon icon="trash"/>
          </button>
        </div>
        <div v-else>
          <button v-b-popover.hover="'Restaurar Material'" class="btn" v-if="data.item.estatus == 'INACTIVO'" @click="restoreMat(data.item)">
              <font-awesome-icon icon="trash-restore" />
          </button>
          <button  v-b-popover.hover="'Cambiar Nombre'" class="btn" v-if="data.item.estatus == 'ACTIVO'" @click="changeNameMat(data.item)">
              <font-awesome-icon icon="edit"/>
          </button>
          <button  v-b-popover.hover="'Eliminar Material'" class="btn" v-if="data.item.estatus == 'ACTIVO'" @click="removeMat(data.item)">
              <font-awesome-icon icon="trash"/>
          </button>
          <button  v-b-popover.hover="'Mostrar Material'" class="btn" v-if="data.item.estatus == 'ACTIVO'" @click="mostrarMat(data.item)">
              <font-awesome-icon icon="eye"/>
          </button>
        </div>
        <!--
        <button @click="btnClicked(button.id,data.item)" class="btn" v-for="button in buttons" :key="button.id" >
            <font-awesome-icon v-if="button.icon" :icon="button.icon" v-b-popover.hover.bottom="button.popover" class="icon-recursos"/>
        </button>
      -->
      </template>
      <template  slot="type" slot-scope="data">
        <div v-if="data.item.typeRec == 'dirs'">
        <font-awesome-icon   icon="folder" class="icon-dir"/>  
        </div>
        <div v-else >
        <font-awesome-icon  icon="file-invoice" class="icon-dir" />
        </div>
      </template>
    </b-table>
    <nav v-if="showPagination">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Siguiente" hide-goto-end-buttons/>
    </nav>
  </b-col>
</template>
<style lang="scss">

  .modal-recurso {
      max-width: 300px !important
  }
  .btn .icon-recursos{
    color: #73818f;
    
    &:hover{
      color: #23282c;
    }
  }
  .table-show-recursos{
    padding-bottom: 15px;
  }
</style>

<script>
import BreadDirectoriosContent from '@/components/BreadDirectoriosContent'
import DirectorioService from '@/services/directorio.service';
import MaterialService from "@/services/material.service";
export default {
  name: 'cTable',
  inheritAttrs: false,
  props: {
    showPagination: {
      type:Boolean,
      default:true
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default: () => {return []}
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 9
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
    }
  },
  computed: {
    items: function() {
      const items =  this.tableData
      return Array.isArray(items) ? items : items()
    },
    totalRows: function () { return this.getRowCount() },
    captions: function() { return this.fields }
  },
  created(){
    console.log('data::',this.items);
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.items.length
    },
    clickedEmit(e){
      this.$emit('row-clicked',e);
    },
    joinArray(array) {
      return array.join();
    },
    btnClicked: function(id,data) {
        if(id && data) {
            let emitter = {
                id: id,
                record: data
            };
            this.$emit('btnClicked', emitter);
        }
    },
    deleteDir(dir){
      this.$swal.fire({
           title: '¿Está seguro?',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar',
          cancelButtonText: 'No, Cancelar'
      }).then((result) => {
           if (result.value) {
              DirectorioService.delete(dir._id).then(response => {
                console.log(response);
              });
           }
      })
    },
    deleteMat(mtls){
      this.$swal.fire({
           title: '¿Está seguro?',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar',
          cancelButtonText: 'No, Cancelar'
      }).then((result) => {
           if (result.value) {
            MaterialService.delete(mtls._id).then(response => {
              console.log("DeleteMaterial: ", response);
            })
           }
      });
    },
    restoreDir(dir) {
      this.restoreMatDir(dir, true);
    },
    restoreMat(mtls) {
      this.restoreMatDir(mtls, false);
    },
    returnDir(id) {
      DirectorioService.list(1,{filtro: { _id: id }}).then(dir => {
        this.routesTree = new Array;
        dir[0].tree.forEach((el,i,a) => {
          let itemData = { text: el.name, rel: el.idDir ? el.idDir : el.name };
          this.routesTree.push(itemData);
          //if(i == a.length - 1) this.$store.dispatch('directorio/setActualTree',this.routesTree);
        });
        this.$emit('change-dir',dir[0]);
      });
    },
    restoreMatDir(element, isDir){
      console.log("Element: ", element, "isDir: ", isDir);

      this.$swal.fire({
        title: '¿Desea Restaurar el Elemento?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'No, Cancelar',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sí, Restaurar'
      }).then(result => {
        if (result.value) {
        console.log("Result modal: ", result.value);
          if (isDir)
            DirectorioService.restore(element._id).then(response => {
              console.log("Response RestoreDir: ", response);
              this.$emit('return-dir', element.father);
          });
          else
            MaterialService.restore(element._id).then(response => {
              console.log("Response RestoreMat: ", response);
              this.$emit('return-dir', element.father);
          });
        }
      });
    },
    changeName(dir) {
      console.log(dir);
      var tree = dir.tree;
      this.$swal
        .fire({
          title: "Editar Nombre",
          text: "Edita el Nombre de la Carpeta",
          input: "text",
          inputPlaceholder: dir.name,
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa"
        })
        .then(result => {
          if (result.value) {
            var newTree = [];
            if (tree.length > 0) {
              tree.forEach(el => {
                if (el.name == dir.name) {
                  el.name = result.value;
                }
                newTree.push(el);
              });
            }
            let data = {
              query: { _id: dir._id },
              data: { name: result.value, tags: [result.value], tree: newTree }
            };
            DirectorioService.edit(data).then(response => {
              this.$emit("return-dir", dir.father);
            });
          }
        });
    },
    changeNameMat(mtls) {
      this.$swal
        .fire({
          title: "Editar Nombre",
          text: "Edita el Nombre del Material",
          input: "text",
          inputPlaceholder: mtls.name,
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa"
        })
        .then(result => {
          if (result.value) {
            let data = {
              query: { _id: mtls._id },
              data: { name: result.value }
            };
            MaterialService.edit(data).then(response => {
              this.$emit("return-dir", mtls.father);
            });
          }
        });
    },
    removeDir(dir) {
      this.$swal
        .fire({
          text: "¿Está Seguro de Eliminar el Directorio?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            DirectorioService.delete(dir._id).then(response => {
              console.log(response);
              this.$emit("return-dir", dir.father);
            });
          }
        });
    },
    removeMat(mtls) {
      this.$swal
        .fire({
          text: "¿Está Seguro de Eliminar el Material?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            MaterialService.delete(mtls._id).then(response => {
              this.$emit("return-dir", mtls.father);
            });
          }
        });
    },
    mostrarMat(material) {
      this.$router.push({
        name: "Editar Material",
        params: { id: material._id }
      });
    }
  }
}
</script>